// extracted by mini-css-extract-plugin
export default {"wrapper":"PositionsCompatibility_wrapper__FNDTz","card":"PositionsCompatibility_card__4akUW","tag":"PositionsCompatibility_tag__ouZdu","title":"PositionsCompatibility_title__t9zrc"};